// extracted by mini-css-extract-plugin
export default {"visuallyHidden":"PreviewTableHeader_visuallyHidden__CZLwA","headerCell":"PreviewTableHeader_headerCell__4dV0H"};